define('models/shared/qanda/question',["backbone",
    "models/shared/qanda/choice_collection"
], function (Backbone, Choices) {

    var Question = Backbone.Model.extend({
        url: function () {
        },
        initialize: function (options) {
            
            options || (options = {});          
            this.questionID = options.QID;
            this.questionText = options.QT;
            this.questionHelpText = options.QHT;
            this.Choices = new Choices(options.Chs, { parse: true });
        },
        parse: function (data) {

            var response = {};           
            response.questionID = data.QID;
            response.questionText = data.QT;
            response.questionHelpText = data.QHT;
            this.Choices = new Choices(data.Chs, { parse: true });         
            return response;
        },
        save: function (attributes, options) {

            options = options || {};
            attributes = attributes || {};
            var data = {};
            data.QID = this.questionID;
            data.QT = this.questionText;
            data.QHT = this.questionHelpText;
            data.Chs = this.Choices;
            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        }
    });

    return Question;
});

